import React from 'react';
import { Label } from 'fw/components';
import { Col, Modal, FormGroup, Row, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { DatePicker } from 'fw/forms';
import { CertificationDisabledStatusCombo } from 'areas/shared/controls';
import * as APIRoutes from 'modules/app/API';
import Moment from 'moment';
import API from 'fw/system/API';
import * as Formatting from 'fw/misc/Formatting';

class ApprovalReviewPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            vobPhones: [],
            primaryContactPhones: [],
        }
    }

    componentWillMount = () => {
        this.loadFinalReviewInfo();
    }

    componentWillReceiveProps(nextProps) {
        var state = this.state;

        state.visible = nextProps.visible;
        this.setState(state);
    }

    loadFinalReviewInfo = () => {
        var rq = {
            certificationId: this.props.certificationId
        };

        new API().get(APIRoutes.Admin.url('/finalReview/getApprovalFinalReviewInfo'), rq,
            {
                success: (r) => {
                    this.setState(r.data);
                }
            });
    }

    close = () => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose();
        });
    }

    onApprovalDateChange = (value) => {
        var date = Moment(value, ["D MMM YYYY", "DD MMM YYYY"], true);
        if (!date.isValid()) {
            this.setState({
                approvalDate: value
            });
            return;
        }

        var expDate = date.add(1, 'year');

        this._expirationDate.setValue(expDate);
        this.setState({
            approvalDate: value,
            expirationDate: expDate
        });
    };

    confirm = () => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onConfirm(this.state);
        });
    }

    render() {
        if (this.state.approvalDate === undefined)
            return null;

        var vobPhones = this.state.vobPhones.map(function (phone, index) {
            return <React.Fragment key={index}>{phone}<br /></React.Fragment>;
        });

        var primaryContactPhones = this.state.primaryContactPhones.map(function (phone, index) {
            return <React.Fragment key={index}>{phone}<br /></React.Fragment>;
        });

        let me = this;
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-60w">
                <Modal.Header>
                    <h3>Approval Preview – App Id: {this.props.certificationId} <small>Please confirm below information in order to generate the certificate.</small></h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        <Row>
                            <Col md={3}>
                                <Label>Company Name:</Label>
                            </Col>
                            <Col md={4}>
                                <Label>{this.state.vobName}</Label>
                            </Col>
                            <Col md={5}>
                                <Label>Primary Contact Information</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Label>Geographic Market:</Label>
                            </Col>
                            <Col md={4}>
                                {this.state.geographicMarket}
                            </Col>
                            <Col md={5}>
                                {this.state.primaryContact}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Label>Number of Employees:</Label>
                            </Col>
                            <Col md={4}>
                                {this.state.employeeNumber}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Label>Service Disabled Veteran:</Label>
                            </Col>
                            <Col md={4}>
                                {this.state.serviceDisabled ? "Yes" : "No"}
                            </Col>
                            <Col md={5}>
                                {this.state.primaryContactEmail}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Label>Website URL:</Label>
                            </Col>
                            <Col md={4}>
                                {Formatting.externalLink(this.state.vobWebsite)}
                            </Col>
                            <Col md={5}>
                                {primaryContactPhones}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Label>Company Phone:</Label>
                            </Col>
                            <Col md={4}>
                                {vobPhones}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                &nbsp;
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Label>Approval Date:</Label>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <DatePicker
                                        required
                                        placeholder="Approval Date"
                                        managed={true}
                                        value={this.state.approvalDate}
                                        onFieldChange={e => me.onApprovalDateChange(e)}
                                        showTime={false}
                                        className='dpThin'
                                    />
                                </FormGroup>

                            </Col>
                            <Col md={3}>
                                <Label>Expiration Date:</Label>
                            </Col>
                            <Col md={3}>
                                <DatePicker
                                    ref={(c) => { this._expirationDate = c; }}
                                    managed={false}
                                    value={this.state.expirationDate}
                                    showTime={false}
                                    disabled={true}
                                    className='dpThin'
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <Label>SDVS:</Label>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <CertificationDisabledStatusCombo
                                        disabled={true}
                                        name="disabledVobStatus" />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                &nbsp;
                            </Col>
                        </Row>
                        <Row>
                            <Col md={1}>
                            </Col>
                            <Col md={10}>
                                <div className="alert" style={{ textAlign: "center", color: "#721c24", backgroundColor: "#f8d7da", borderColor: "#f5c6cb" }}>
                                    <strong>
                                        <FontAwesomeIcon icon={faExclamationTriangle} size="1x" />
                                                            &nbsp;&nbsp;Attention! This action cannot be undone.
                                                        </strong>
                                </div>
                            </Col>
                        </Row>
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" onClick={this.confirm}>Confirm</Button>
                    <Button onClick={this.close}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ApprovalReviewPopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/finalReview/ApprovalReviewPopUp.js